<template>
    <!-- v-if="page.total>9" -->
    <div class="v_pagination" >

    <el-pagination
    background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :page-sizes="[10,20,50]"
        :current-page="page.page"
        :page-size="page.num"
        layout="total, sizes, prev, pager, next"
        :total="page.count"
    >
    <!-- :hide-on-single-page="true" -->
    </el-pagination>
</div>

</template>
<script>
export default {
    props:{
        page:{
                type:Object,
                default:"",
                required:false
            }
    },
    methods: {
        handleCurrentChange(val) {
            this.$emit('getPage',val)
        },
        handleSizeChange(val) {
        this.$emit('getNum',val)
       
      },
    },
    data() {
        return {
           
        };
    }
};
</script>
<style lang="scss" scoped>
/deep/.el-pagination{
    margin-left: 10px !important;
}
/deep/.el-pagination  .el-select{
    width: initial !important;
    margin: initial !important;
}

/deep/.el-pagination  .el-input__inner {
    background: rgba(43, 43, 43, 1) !important;
    color: rgba(245, 245, 245, 1) !important;
    font-size: 12px !important;
    line-height: 21px !important;
    height: 32px !important;
    border-radius: 0px 1px 1px 0px !important;

    border: 1px solid #212121 !important;
}
/deep/.el-pagination  .el-input__inner:hover {
    background: rgba(33, 33, 33, 1) !important;
}
/deep/.el-pagination .el-pagination__sizes  {
    margin: 0 !important;
   

}
/deep/.el-pagination .el-pagination__sizes .el-select .el-select--mini {
    margin: 0 !important;
}
.v_pagination{
    height: 44px;
    display: flex;
    align-items: center;
}
/deep/.el-pagination__total{
    font-size: 12px !important; 
    color: rgba(217, 217, 217, 1) !important;
}
/deep/.el-pager, .el-pager li {
    display: flex;
    align-items: center;
}
/deep/.el-pager .number{
    background: none !important;

    height: 40px;
    line-height: 40px;
}
/deep/.el-pagination{
    display: flex;
    align-items: center;
    padding: 0 !important;
}
/deep/.el-pager .active{

}
/deep/.el-pagination.is-background .btn-next {
    background: none !important;

}
/deep/.el-pagination.is-background .btn-prev{
    background: none !important;

}
</style>
